import { formFieldPropsType, } from "../../lib/formControlFactory";
import { outerLayoutMixinPropsType, } from "../../mixins/outerLayout";
export const textFieldPropsType = formFieldPropsType
    .extend(outerLayoutMixinPropsType)
    .complete({
    role: true,
    className: true,
    placeholder: true,
    _internal: true,
    onClick: true,
    iconProps: true,
    buttonRight: true,
    clear: true,
    type: true,
    icon: true,
    id: true,
    textSuffix: true,
    autoFocus: true,
    autoComplete: true,
    hidden: true,
    inputMode: true,
    onBeforeInputCapture: true,
    onBlur: true,
    onClear: true,
    onFocus: true,
    onInput: true,
    onInputCapture: true,
    onKeyDown: true,
    onKeyPress: true,
    readOnly: true,
    _borderRadius: true,
    maxLengthInformationThreshold: true,
    gradientBorder: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UZXh0RmllbGQvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUdMLGtCQUFrQixHQUNuQixNQUFNLDhCQUE4QixDQUFDO0FBRXRDLE9BQU8sRUFFTCx5QkFBeUIsR0FDMUIsTUFBTSwwQkFBMEIsQ0FBQztBQTZGbEMsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQUcsa0JBQWtCO0tBQ2pELE1BQU0sQ0FBQyx5QkFBeUIsQ0FBQztLQUNqQyxRQUFRLENBQWlCO0lBQ3hCLElBQUksRUFBRSxJQUFJO0lBQ1YsU0FBUyxFQUFFLElBQUk7SUFDZixXQUFXLEVBQUUsSUFBSTtJQUNqQixTQUFTLEVBQUUsSUFBSTtJQUNmLE9BQU8sRUFBRSxJQUFJO0lBQ2IsU0FBUyxFQUFFLElBQUk7SUFDZixXQUFXLEVBQUUsSUFBSTtJQUNqQixLQUFLLEVBQUUsSUFBSTtJQUNYLElBQUksRUFBRSxJQUFJO0lBQ1YsSUFBSSxFQUFFLElBQUk7SUFDVixFQUFFLEVBQUUsSUFBSTtJQUNSLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFNBQVMsRUFBRSxJQUFJO0lBQ2YsWUFBWSxFQUFFLElBQUk7SUFDbEIsTUFBTSxFQUFFLElBQUk7SUFDWixTQUFTLEVBQUUsSUFBSTtJQUNmLG9CQUFvQixFQUFFLElBQUk7SUFDMUIsTUFBTSxFQUFFLElBQUk7SUFDWixPQUFPLEVBQUUsSUFBSTtJQUNiLE9BQU8sRUFBRSxJQUFJO0lBQ2IsT0FBTyxFQUFFLElBQUk7SUFDYixjQUFjLEVBQUUsSUFBSTtJQUNwQixTQUFTLEVBQUUsSUFBSTtJQUNmLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsYUFBYSxFQUFFLElBQUk7SUFDbkIsNkJBQTZCLEVBQUUsSUFBSTtJQUNuQyxjQUFjLEVBQUUsSUFBSTtDQUNyQixDQUFDLENBQUMifQ==